// extracted by mini-css-extract-plugin
export default {"hiding":"VisuallyHiding_hiding__5OHQL","placeHolderShimmer":"VisuallyHiding_placeHolderShimmer__pz6p3"};